import { Sensor } from '../types/api';

const FIRST_JAMESTOWN_BUILD = 7975;
export const FIRST_BUILD_WITH_SENSOR_LOCATE_AND_IMMEDIATE_COMMANDS = 10094;

// Given a sensor, return the os build number part os the os version
export function extractOSBuildNumber(
  osVersion: Sensor['os_version'],
): number | null {
  if (!osVersion) {
    return null;
  }

  const buildNumber = window.parseInt(osVersion.split('-')[0], 10);
  if (isNaN(buildNumber)) {
    return null;
  }

  return buildNumber;
}

export function supportsDenseCaptures(n: {
  os_version: Sensor['os_version'];
}): boolean {
  return true;
}

export function supportsLocate(n: {
  os_version: Sensor['os_version'];
}): boolean {
  return (
    extractOSBuildNumber(n.os_version) >=
    FIRST_BUILD_WITH_SENSOR_LOCATE_AND_IMMEDIATE_COMMANDS
  );
}
